import React from 'react';
import './TextSlider.css';

const TextSlider = () => {
  const texts = [
    'Dalhousie University',
    'University of Windsor',
    'Memorial University',
    'University of Prince Edward Island',
    'University of New Brunswick',
    'Trent University',
    'University of Calgary',
    'University of Regina',
    'Wilfrid Laurier University',
    'Niagara University',
    'Ontario Tech University',
    'University of Law',
    'University of Keele',
    'Arden University',
    'Canterbury Christ Church University',
    'University of Jyväskylä',
    'University of Debrecen',
    'John Von Neumann University',
    'Hungarian University of Sports Science',
    'Budapest University of Economics and Business',
    'Centennial College',
    'Seneca College',
    'Sheridan College',
    'Lambton College',
    'Georgian College',
    'St. Clair College',
    'Justice Institute British Columbia',
    'Conestoga College',
    'Niagara College',
  ];

  const handleClick = (text) => {
    // alert(`Clicked on: ${text}`);
  };

  return (
    <div style={{ marginTop: -30, zIndex:100 ,}} className="text-slider-container">
      <div className="text-slider">
        <div  className="text-slider-content">
          {texts.map((text, index) => (
            <span key={index} className="text-item" onClick={() => handleClick(text)}>
              {text} |
            </span>
          ))}
          {texts.map((text, index) => (
            <span key={`dup-${index}`} className="text-item" onClick={() => handleClick(text)}>
              {text} |
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TextSlider;
